<div [class]="classes()">
  @if (icon()) {
    <app-icon
      [dense]="true"
      [icon]="icon()!"
    />
  }
  {{ label() }}
</div>
